import { render } from "./ProfileChart.vue?vue&type=template&id=ffab734c"
import script from "./ProfileChart.vue?vue&type=script&lang=js"
export * from "./ProfileChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__